
import { defineComponent } from 'vue';
import ReportOptionComponent from '@/components/reportsComponents/ReportOption.vue';
import WithdrawalsCrypto from './WithdrawalsCrypto.vue';
import SystemGateways from '@/views/SystemGateways.vue';
import ExchangeSetting from './ExchangeSetting.vue';
import store from '@/store';

export default defineComponent({
    name: "ExchangePage",

    components: { ReportOptionComponent, WithdrawalsCrypto, SystemGateways, ExchangeSetting },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: "تسویه",
                    path: "withdrawal",
                    icon: 'mdi-cash'
                },
                {
                    title: "کارمزد درگاه‌ها",
                    path: "systemGateways",
                    icon: 'mdi-cash'
                },
                {
                    title: "تنظیمات",
                    path: "setting",
                    icon: 'mdi-cog'
                },
            ]
        }
    },

    created() {
        this.syncStatusComponent(this.$route.query.path);
    },

    methods: {
        syncStatusComponent(path: unknown): void {
            this.statusComponent =
                path === "withdrawal" || path === "setting" || path === "systemGateways"
                    ? path
                    : "Menu";
        },

        changeStatusComponent(status: string): void {
            const isSupportedStatus =
                status === "withdrawal" || status === "setting" || status === "systemGateways";
            this.statusComponent = isSupportedStatus ? status : "Menu";
            this.$router.push({
                query: { ...this.$route.query, path: isSupportedStatus ? status : undefined },
            });
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: unknown) {
            this.syncStatusComponent(newPath);
        },
    },

    mounted() {
        store.dispatch("panel/getExchangeSettingRequest")
    }
})
